module.exports = __webpack_public_path__ + "static/media/app-store-badge.fabed2f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/app-store-badge.svg
// module id = 825
// module chunks = 0